import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDeleteSaleMutation } from '../salesApiSlice'

const formatNumber = (value) => {
	if (value === null || value === undefined || value === "") return "—";

	const num = Number(value);
	if (Number.isNaN(num)) return "—";

	return num.toLocaleString("id-ID", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

// If you want a separate one for qty (no decimals), you can do:
const formatQty = (value) => {
	if (value === null || value === undefined || value === "") return "—";

	const num = Number(value);
	if (Number.isNaN(num)) return "—";

	return num.toLocaleString("id-ID", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
};

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "—";

  const num = Number(value);
  if (Number.isNaN(num)) return "—";

  return num.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0, // or 2 if you prefer
  });
};


export default function SaleRow({ sale }) {
    const [deleteSale, { isLoading }] = useDeleteSaleMutation();

    // template literal for date formatting with fallback
    // const created = sale.createdAt ? format(new Date(sale.createdAt), "yyyy-MM-dd") : "—";
    const dated = sale.date ? format(new Date(sale.date), "yyyy-MM-dd") : "—";

    const handleDelete = async () => {
        try {
            await deleteSale({ id: sale._id }).unwrap()
            alert(`Sale '${sale.title}' deleted successfully`)
        } catch (err) {
            console.error("Delete error:", err)
            alert(err?.data?.message || "Failed to delete sale")
        }
    }

    return (
        <tr className="hover:bg-gray-50/40">
            <td className="px-6 py-3 text-sm text-gray-900 font-medium">{dated}</td>
            {/* <td className="px-6 py-3 text-sm text-gray-600">{sale.no_do || "—"}</td> */}
            <td className="px-6 py-3 text-sm text-gray-600">{sale.city || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{sale.customer_category || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{sale.customer_detail || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatQty(sale.qty) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatNumber(sale.unit_price) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatNumber(sale.total) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatQty(sale.total) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatNumber(sale.net_sales) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatNumber(sale.ppn) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">{formatNumber(sale.debet) || "—"}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{sale.main_company || "—"}</td>
            <td className="px-6 py-3 text-right">
                <div className="inline-flex gap-2">
                <Link
                    to={`/dash/sales/${sale._id}`}  
                    className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                >
                    Edit
                </Link>
                <button
                    onClick={handleDelete}
                    disabled={isLoading}
                    className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                >
                    {isLoading ? "Deleting..." : "Delete"}
                </button>
                </div>
            </td>
        </tr>
    );
}
